import React from 'react';

import YouTubePlayer from '@components/pages/PageTemplates/Blocks/VideoBlock/YouTube';

import { MAX_YOUTUBE_VIDEO_WIDTH } from './constants';

const TITVSection = ({ latestTITVEpisodeID }: { latestTITVEpisodeID?: string }) => {
  const youtubeURL = `https://youtu.be/${latestTITVEpisodeID}`;

  return (
    <section className="pt-64 sm:pt-112">
      <div className="mx-auto flex max-w-[500px] flex-col items-center gap-24">
        <h2 className="m-0 text-center font-suisse-works text-headline-sm text-black sm:text-headline-lg">
          The Information’s TITV
        </h2>
        <p className="m-0 text-center font-suisse-intl-mono text-caption-md text-black">
          Weekdays at 10 am PT / 1 pm ET
        </p>
        <p className="m-0 text-center font-suisse-neue text-body-lg text-black">
          The Information’s TITV is first in tech news and analysis from the people who break and
          shape the story. The rest is just commentary.
        </p>
      </div>
      <div className="mt-32">
        <div
          aria-label="TITV video preview"
          className="mx-auto flex aspect-[16/9] w-full max-w-[750px] items-center justify-center bg-grayscale-charcoal"
          role="img"
        >
          <YouTubePlayer content={{ src: youtubeURL }} maxWidth={MAX_YOUTUBE_VIDEO_WIDTH} />
        </div>
      </div>
    </section>
  );
};

export default TITVSection;
